import SEO from "../components/SEO";
import PageHeader from "../components/PageHeader";
import EmptyState from "../components/EmptyState";
import { Reveal } from "../components/Reveal";

const AXES = [
  { title: "Coopération sportive", text: "Construire des liens durables avec les acteurs du cyclisme sénégalais : clubs, structures et fédération." },
  { title: "Cyclisme féminin", text: "Soutenir le développement du cyclisme féminin au Sénégal, au cœur de l'engagement du club." },
  { title: "Échanges sportifs", text: "Organiser des échanges entre coureurs, coureuses et encadrants des deux territoires." },
  { title: "Formation", text: "Partager l'expérience du club en matière de formation et d'encadrement des jeunes." },
  { title: "Clubs & structures", text: "Accompagner des projets menés avec les clubs et structures cyclistes sénégalaises." },
  { title: "Événements futurs", text: "Des événements et actions concrètes seront annoncés au fil de l'avancement du projet." },
];

export default function Senegal() {
  return (
    <>
      <SEO title="Savoir Rouler & Sénégal" description="Le Club Cycliste Le Boulou intervient dans les écoles primaires avec le Savoir Rouler à Vélo et développe des projets de coopération cycliste au Sénégal." />
      <PageHeader kicker="Le Club" title="Savoir Rouler & Sénégal" />

      <section className="py-20 sm:py-28">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
          <Reveal>
            <div className="flex items-center gap-4 mb-6">
              <span className="font-heading text-sm tracking-[0.3em] text-rouge font-semibold">01</span>
              <span className="h-px w-12 bg-rouge" />
            </div>
            <h2 className="font-heading uppercase font-semibold tracking-tighter text-navy text-3xl sm:text-5xl">
              Savoir Rouler à Vélo
            </h2>
            <p className="mt-6 max-w-3xl text-navy/80 text-lg sm:text-xl leading-relaxed" data-testid="savoir-rouler-text">
              Le Club Cycliste Le Boulou intervient dans les écoles primaires du territoire dans le cadre du
              dispositif « Savoir Rouler à Vélo ». L'objectif : permettre à chaque enfant d'apprendre à maîtriser son
              vélo, à circuler en sécurité et à gagner en autonomie avant l'entrée au collège. Encadrées par les
              bénévoles et entraîneurs du club, ces séances transmettent les bons réflexes, le respect des règles et
              surtout le plaisir de se déplacer à vélo.
            </p>
          </Reveal>

          <div className="mt-20 sm:mt-28">
            <Reveal>
              <div className="flex items-center gap-4 mb-6">
                <span className="font-heading text-sm tracking-[0.3em] text-rouge font-semibold">02</span>
                <span className="h-px w-12 bg-rouge" />
              </div>
              <h2 className="font-heading uppercase font-semibold tracking-tighter text-navy text-3xl sm:text-5xl">
                Projet Sénégal
              </h2>
              <p className="mt-6 max-w-3xl text-navy/80 text-lg sm:text-xl leading-relaxed">
                Du Boulou à Dakar : le Club Cycliste Le Boulou s'engage dans des projets de développement du cyclisme au
                Sénégal, avec une attention particulière portée au cyclisme féminin. Cette rubrique présentera
                progressivement les actions menées avec les acteurs du cyclisme sénégalais.
              </p>
            </Reveal>

            <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {AXES.map((a, i) => (
                <Reveal key={a.title} delay={i * 0.07}>
                  <div className="group bg-white border border-navy/10 p-8 h-full hover:border-rouge transition-[border-color] duration-300">
                    <span className="font-heading font-semibold text-3xl text-outline-navy group-hover:text-rouge group-hover:[-webkit-text-stroke:0px] transition-all duration-300">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h3 className="mt-4 font-heading uppercase font-semibold tracking-tight text-navy text-xl">{a.title}</h3>
                    <p className="mt-3 text-sm text-steel leading-relaxed">{a.text}</p>
                  </div>
                </Reveal>
              ))}
            </div>

            <div className="mt-16">
              <EmptyState
                title="Actualités du projet à venir"
                message="Les avancées concrètes du projet Sénégal seront publiées ici et dans les actualités du club, catégorie « Sénégal »."
                testId="senegal-updates-empty"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
